import {
  Directive,
  ElementRef,
  Input,
  SecurityContext,
  inject,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({ selector: '[appAddHtml]' })
export class AddHtmlDirective {
  private sanitizer = inject(DomSanitizer);
  private elementRef = inject(ElementRef);

  @Input() public set appAddHtml(data: string) {
    this.elementRef.nativeElement.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, data);
  }
}
